/**
 * Issue Navigation
 **/
export const EditorialIntro = function( $ ) {

	const EditorialIntro = {

		elements: {
			$editorialIntroSection: $( '.section-editorial-intro' ),
			$editorialIntro: $( '.editorial-intro' ),
			$editorialIntroTrigger: $( '.editorial-intro-expand-link' ),
		},

		expand() {
			EditorialIntro.elements.$editorialIntro.addClass( 'is-expanded' );
		},

	};

	EditorialIntro.elements.$editorialIntroTrigger.click( function( e ) {
		e.preventDefault();
		EditorialIntro.expand();
	} );

	return EditorialIntro;

}( jQuery );
